import { createRoot, type Root } from "react-dom/client";
import ToastManager from "./ToastManager";
import { Notification, NotificationGroup } from "types/Notification";
import { uuidv4 } from "component/utils/uuid.utils";

class Toaster {
  private root?: Root;
  private notifyHandler?: (notification: Notification) => void;
  private closeAllHandler?: () => void;

  constructor() {
    const container = document.createElement("div");
    container.setAttribute("data-octal-toaster-container", "");

    document.body.append(container);

    this.root = createRoot(container);
    this.root.render(
      <ToastManager bindNotify={this.bindNotify} bindCloseAll={this.bindCloseAll} />,
    );
  }

  private bindNotify = (handler: any) => {
    this.notifyHandler = handler;
  };

  private bindCloseAll = (handler: any) => {
    this.closeAllHandler = handler;
  };

  public success = (title: string) => {
    this.notify({
      id: uuidv4(),
      group: NotificationGroup.DEFAULT,
      intent: "SUCCESS",
      priority: "NORMAL",
      title: title,
      createdAt: new Date().toISOString(),
    });
  };

  public notify = (notification: Notification) => {
    this.notifyHandler && this.notifyHandler(notification);
  };

  public closeAll = () => {
    this.closeAllHandler && this.closeAllHandler();
  };
}

export default new Toaster();
